import de from '../../translation/de_DE'

export default {
  // i18nConfiguration
  i18n: {
    locales: [
      {
        code: 'de',
        iso: 'de-DE',
      },
    ],
    defaultLocale: 'de',
    vueI18n: {
      fallbackLocale: 'de',
      messages: {
        de,
      },
    },
    pages: {
      'categories/inspirations': {
        de: '/inspirationen',
      },
      'categories/gifts': {
        de: '/geschenke',
      },
      'categories/occasions': {
        de: '/anlasse',
      },
      'categories/tutorials-and-advices': {
        de: '/tutorials-und-tipps',
      },
      'categories/home-furnishing': {
        de: '/wohndeko',
      },
      'editorial-staff/index': {
        de: '/redazione',
      },
      'editorial-staff/_author': {
        de: '/redazione/:author?',
      },
    },
  },
  /* 
    Categories Configuration
    @order: [] è l'array delle chiavi delle categorie e rappresenta l'ordine con cui verranno visualizzate le categorie dove richieste
    list{
        @key è la chiave della categoria. Per convenzione chiamata come il folder dentro page.
        {
          @slug è lo slug della categoria inserito in categorie su Wordpress
          @view è la view di nuxt e corrisponde al name utilizzato nei nuxt-link
        }
    }
  */
  pages: {
    // leggere README.md
    list: [
      {
        key: 'index', // Home per comodità la trattiamo come una categoria
        wpUri: '/?page_id=349',
      },
      {
        key: 'inspirations',
        wpUri: '/?page_id=353',
      },
      {
        key: 'gifts',
        wpUri: '/?page_id=355',
      },
      {
        key: 'occasions',
        wpUri: '/?page_id=351',
      },
      {
        key: 'tutorials-and-advices',
        wpUri: '/?page_id=359',
      },
      {
        key: 'home-furnishing',
        wpUri: '/?page_id=357',
      },
      {
        key: 'editorial-staff',
        wpUri: '/redazione/',
      },
    ],
  },
  categories: {
    // leggere README.md
    list: [
      {
        key: 'inspirations',
        wpSlug: 'inspirations',
        view: 'categories-inspirations',
        wpCategoryId: 5,
      },
      {
        key: 'gifts',
        wpSlug: 'gifts',
        view: 'categories-gifts',
        wpCategoryId: 6,
      },
      {
        key: 'occasions',
        wpSlug: 'occasions',
        view: 'categories-occasions',
        wpCategoryId: 4,
      },
      {
        key: 'tutorials-and-advices',
        wpSlug: 'tutorials-and-advices',
        view: 'categories-tutorials-and-advices',
        wpCategoryId: 8,
      },
      {
        key: 'home-furnishing',
        wpSlug: 'home-furnishing',
        view: 'categories-home-furnishing',
        wpCategoryId: 7,
      },
      {
        key: 'highlights',
        wpSlug: 'highlights',
        view: null,
        wpCategoryId: 3,
      },
    ],
  },
  giftaWebsite: 'https://www.gifta.de/',
  navigation: {
    primary: {
      order: [
        'inspirations',
        'gifts',
        'occasions',
        'tutorials-and-advices',
        'home-furnishing',
      ],
    },
    // Categorie che vengono filtrate da eventuali elenchi (es. la lista delle categorie a cui appartiene un post)
    exclude: ['highlights'],
  },
  social: [
    {
      key: 'facebook',
      url: 'https://www.facebook.com/Giftade-103952284877014',
    },
    {
      key: 'instagram',
      url: 'https://www.instagram.com/gifta.de/?hl=it',
    },
  ],
  terms: [
    {
      key: 'privacy-policy',
      url: 'https://www.gifta.de/privacy-policy/',
    },
    {
      key: 'cookie-policy',
      url: 'https://www.gifta.de/cookie/',
    },
    {
      key: 'informazioni-legali',
      url: 'https://www.gifta.de/impressum',
    },
  ],
  pixaLinks: [
    {
      key: 'books-magazines',
      url: 'https://www.pixartprinting.de/broschueren-drucken/',
    },
    {
      key: 'business-cards',
      url: 'https://www.pixartprinting.de/visitenkarten/',
    },
    {
      key: 'flyers',
      url: 'https://www.pixartprinting.de/digitaldruck-offsetdruck-online/flyer-drucken/',
    },
  ],
  shopLinks: [
    {
      label: 'Personalisierte Geschenke',
      url: 'https://www.gifta.de/personalisierte-geschenke/',
    },
    {
      label: 'Leinwanddrucke',
      url: 'https://www.gifta.de/foto-auf-leinwand/',
    },
    {
      label: 'Leinwandbilder',
      url: 'https://www.gifta.de/foto-auf-leinwand/leinwandbilder/',
    },
    {
      label: 'Wanddekorationen',
      url: 'https://www.gifta.de/wanddeko/',
    },
    {
      label: 'Fotogeschenke',
      url: 'https://www.gifta.de/fotogeschenke/',
    },
    {
      label: 'Personalisierte Kissen',
      url: 'https://www.gifta.de/fotogeschenke/personalisierte-kissen/',
    },
    {
      label: 'Fototassen',
      url: 'https://www.gifta.de/fotogeschenke/fototassen/',
    },
    {
      label: 'Personalisierte Tote Bags',
      url: 'https://www.gifta.de/fotogeschenke/tote-bags-bedrucken/',
    },
    {
      label: 'Selbst Gestaltete T-Shirts',
      url: 'https://www.gifta.de/t-shirts-bedrucken/',
    },
    {
      label: 'Fotobücher',
      url: 'https://www.gifta.de/fotobuecher/',
    },
    {
      label: 'Fotokalender',
      url: 'https://www.gifta.de/fotokalender/',
    },
    {
      label: 'Geschenkideen',
      url: 'https://www.gifta.de/geschenkideen/',
    },
  ],
  nuxtConfiguration: {
    head: {
      script: [
        {
          src: 'https://21fd768e7ea04855a8a850bd8ab542cf.js.ubembed.com',
          async: true,
        },
      ],
    },
  },
}
